export const userAgent = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    userAgent: null,
    isChromeAccess: null,
    isAllowedBrowserAccess: null
  },
  getters: {
    getUserAgent: state => state.userAgent,
    getIsChromeAccess: state => state.isChromeAccess,
    getIsAllowedBrowserAccess: state => state.isAllowedBrowserAccess
  },
  mutations: {
    set(state, _) {
      const userAgent = window.navigator.userAgent;
      state.userAgent = userAgent;
      state.isChromeAccess = userAgent.includes('Chrome') && !userAgent.includes('Edg');
      state.isAllowedBrowserAccess = userAgent.includes('Chrome') || userAgent.includes('Edg');
    },
    clear(state) {
      state.userAgent = null;
      state.isChromeAccess = null;
      state.isAllowedBrowserAccess = null;
    }
  },
  actions: {
    setData(context, payLoad) {
      context.commit('clear');
      context.commit('set', payLoad);
    },
    clearData(context) {
      context.commit('clear');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user_agent.js